module.exports = __webpack_public_path__ + "static/media/faded-dashes-background.750eded5.png";